import declare from "dojo/_base/declare";
import Expression from "csi/heading/Expression";
import MaterialIcon from "csi/widget/MaterialIcon";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import { C8NodeType } from "src/c8-platform/type/node";

const ConditionalMaterialIcon = declare(Expression, {
	/** material icon to render */
	icon: "",

	/**
	 * @override
	 * Render icon if expression value is true
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement): boolean {
		const { icon } = this;
		const value = this._getValue(ctx, h);
		if (icon && value) {
			new MaterialIcon({
				icon,
				style: "cursor: initial; margin-top: -2px;",
			}).placeAt(refNode);
			return true;
		}
	},

	/**
	 * @override
	 * Center the icon in the cell
	 */
	_getCSS(type: C8NodeType, format?: string): string {
		return "attrBoolean";
	},
});

export = ConditionalMaterialIcon;
